import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import { v4 as uuidv4 } from "uuid";
// SYSTEM-1
import { IEngagementActivity } from "@/store/models/engagements/engagementActivity";
import { EngagementActivityDocModel } from "@/store/models/engagements/engagementActivityDoc";
import EngagementsModule from "@/store/modules/engagements.module";
import { toaster } from "@/utilities/toaster";
import BaseMixer from "../../BaseMixer";
import DeleteComponent from "@/components/deleteComponent.vue";
let StageActivityDocs = /** @class */ (() => {
    var _a;
    let StageActivityDocs = class StageActivityDocs extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.isEditing = false;
            this.showDeleteDocument = false;
            // private isClicked: boolean = false;
            this.engagementActivityDoc = new EngagementActivityDocModel();
        }
        saveDocument() {
            this.validate("engagementActivityDocObserver").then((response) => {
                if (response) {
                    this.engagementActivityDoc.id = uuidv4();
                    this.engagementActivityDoc.activityId = this.model.activityId;
                    EngagementsModule.SaveActivityDocument(this.engagementActivityDoc).then((response) => {
                        this.engagementActivityDoc = new EngagementActivityDocModel();
                        this.isEditing = false;
                        toaster.ShowApiSuccess(response);
                    });
                }
            });
        }
        deleteDocument(document) {
            this.engagementActivityDoc.id = document.id;
            this.engagementActivityDoc.activityId = document.activityId;
            this.showDeleteDocument = true;
        }
        deletingDocument() {
            EngagementsModule.DeleteActivityDocument(this.engagementActivityDoc).then((response) => {
                this.showDeleteDocument = false;
                this.engagementActivityDoc = new EngagementActivityDocModel();
                toaster.ShowApiSuccess(response);
            });
        }
        resetDoc() {
            this.engagementActivityDoc = new EngagementActivityDocModel();
            this.isEditing = false;
        }
        get hasDocs() {
            return this.model.docs.length > 0;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IEngagementActivity !== "undefined" && IEngagementActivity) === "function" ? _a : Object)
    ], StageActivityDocs.prototype, "model", void 0);
    StageActivityDocs = __decorate([
        Component({
            name: "StageActivityDocs",
            components: {
                DeleteComponent,
            },
        })
    ], StageActivityDocs);
    return StageActivityDocs;
})();
export default StageActivityDocs;
